module.exports = __webpack_public_path__ + "static/media/chewron_down.6e8950aa.svg";